var _slicedToArray = require("/home/runner/work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _createForOfIteratorHelper = require("/home/runner/work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");
var _classCallCheck = require("/home/runner/work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/home/runner/work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _inherits = require("/home/runner/work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _createSuper = require("/home/runner/work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");
var OrangeChartAbstractGrid = require('./orange-chart-abstract-grid');
var _require = require('orange-svg'),
  OrangeSVGPolyline = _require.OrangeSVGPolyline,
  OrangeSVGPolygon = _require.OrangeSVGPolygon,
  OrangeSVGCircle = _require.OrangeSVGCircle;
var OrangeChartLines = /*#__PURE__*/function (_OrangeChartAbstractG) {
  "use strict";

  _inherits(OrangeChartLines, _OrangeChartAbstractG);
  var _super = _createSuper(OrangeChartLines);
  function OrangeChartLines(data) {
    _classCallCheck(this, OrangeChartLines);
    if (data.length < 2) throw new Error('You can\'t create lines chart with only one object in the data array');
    return _super.call(this, data);
  }

  /**
   *
   * @param {OrangeSVG} svg
   * @param {[number, number, number][]} data
   * @param {string} color
   * @param {string} property
   * @param {object} view
   * @param {{y2: number}} position
   * @protected
   */
  _createClass(OrangeChartLines, [{
    key: "_do_render_elements",
    value: function _do_render_elements(svg, data, color, property, view, position) {
      var area_opacity = view.hasOwnProperty('area') && (view.area === true || view.area.includes(property)) ? view.hasOwnProperty('area_opacity') ? view.area_opacity : 0.5 : null;
      var callbacks = this.getCallbacks(property);
      if (area_opacity !== 1) {
        var line = new OrangeSVGPolyline(data, color, view.hasOwnProperty('area_opacity') ? view.area_opacity : null);
        line.args = {
          'data-property': property,
          'class': 'orange-chart-lines-line'
        };
        svg.appendChild(line);
      }
      if (area_opacity !== null) {
        var polygon = new OrangeSVGPolygon(data.map(function (v) {
          return v.slice(0, 2);
        }).concat([[data[data.length - 1][0], position.y2], [data[0][0], position.y2]]), color, area_opacity);
        polygon.args = {
          'data-property': property,
          'class': 'orange-chart-lines-area'
        };
        svg.appendChild(polygon);
      }
      if (view.hasOwnProperty('dots') && (view.dots === true || view.dots.includes(property))) {
        var i = 0;
        var _iterator = _createForOfIteratorHelper(data),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _step$value = _slicedToArray(_step.value, 4),
              x = _step$value[0],
              y = _step$value[1],
              _ = _step$value[2],
              row = _step$value[3];
            var circle = new OrangeSVGCircle(x, y, view.hasOwnProperty('radius') ? view.radius : 2, color);
            circle.args = {
              'data-property': property,
              'class': 'orange-chart-lines-dot'
            };
            svg.appendChild(circle, callbacks, {
              property: property,
              row: row,
              'value': {
                'x': this._data[i][this._axes['x'].source],
                'y': this._data[i][property]
              }
            });
            ++i;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }
  }]);
  return OrangeChartLines;
}(OrangeChartAbstractGrid);
module.exports = OrangeChartLines;